<template>
  <b-modal
    id="copyCommissions"
    size="md"
    ok-only
    ok-title="Chiudi"
    ok-variant="lisaweb"
    header-bg-variant="lisaweb"
    no-close-on-esc
    no-close-on-backdrop
  >
    <template v-slot:modal-header-close>
      <base-icon name="close" width="14" height="14"/>
    </template>
    <template #modal-title>
      <div slot="modal-title" class="modal-title">
        <!-- <b-icon icon="cash"></b-icon> -->
        <span>{{ title }}</span>
      </div>
    </template>

    <template #modal-footer="{ cancel }">
      <div style="display: flex; flex-direction: row; gap: 10px;">
        <b-button
          @click="
            reset();
            cancel();
          "
          size="sm"
          variant="-transparent"
        >Annulla
        </b-button
        >
        <b-button
          class="btn-lisaweb"
          :disabled="!salesman_id || salesman_id.length === 0"
          @click="
            $emit('copy', salesman_id);
            reset();
            cancel();
          "
          size="sm"
          variant="-lisaweb"
        >Copia
        </b-button
        >
      </div>
    </template>
    <b-row>
      <!-- testo libero -->
      <p class="col-md-12 mb-3 mt-2" v-html="text"></p>
      <div class="col-md-8">
        <base-select
          name="cod_prod"
          label="Produttore"
          :options="salesmen_select"
          v-model="salesman_id"
          :multiple="true"
          :closeOnSelect="false"
          :taggable="salesmen_taggable"
          :defaultHtmlMultipleSelect="true"
          @changeTaggable="changeTaggable"
        >
          <template #advanced-actions>
            <b-button
              :pressed.sync="myToggle"
              variant="light"
              class="btn--smaller btn--x-smaller btn--transparent"
              @click="myToggle ? selectAllBrokers() : deselectAllBrokers()"
            >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
            </b-button>
            <b-button
              :pressed.sync="myTogglePO"
              variant="light"
              class="btn--smaller btn--x-smaller btn--transparent"
              @click="
                      myTogglePO ? salesmenOrderByCode() : salesmenOrderByName()
                    "
            >{{ myTogglePO ? "Ordine per nome" : "Ordina per codice" }}
            </b-button>
          </template>
        </base-select>
      </div>
    </b-row>
  </b-modal>
</template>
<script>
import BaseSelect from "@/components/form/BaseSelect";
import BaseIcon from "@/components/BaseIcon";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      options: [],
      myToggle: false,
      myTogglePO: false,
      salesmen_select: [],
      salesman_id: null,
      salesmen: [],
      salesmen_taggable: true,
    };
  },
  components: {
    BaseSelect,
    BaseIcon
  },
  props: {
    opts: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: "Opzioni",
    },
    text: {
      type: String,
      default: "",
    },
  },
  computed: {},
  beforeMount() {
    this.salesmen = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    this.salesmen_select = this.salesmen;
  },
  methods: {
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllBrokers() {
      this.salesman_id = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllBrokers() {
      // this.salesman_id = [];
      this.salesman_id = null;
    },
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    onOption() {
      if (this.options.length) {
        this.myToggle = this.options.length === this.opts.length;
      } else {
        this.myToggle = false;
      }
    },
    onToggle() {
      if (this.myToggle) {
        this.options = this.opts.map((e) => e.value);
      } else {
        this.options = [];
      }
    },
    reset() {
      this.options = [];
      this.myToggle = false;
    },
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
    }),
  },
};
</script>
<style lang="scss" scoped></style>
